module.exports = __webpack_public_path__ + "public/img/w6.891de2ce.png";